import { Link } from 'react-router-dom';
import { Youtube, Mail } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';
import { NAV_ITEMS, YOUTUBE_GAMEDEV, CONTACT_EMAIL } from '../data/divisions';
import { Logo } from './Logo';
import './Footer.css';

export function Footer() {
  const { t } = useI18n();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <Logo size={30} />
            <span>Sky<span className="app-title-accent">codee</span></span>
          </Link>
          <p className="footer-tagline">{t('footer.tagline')}</p>
          <div className="footer-social">
            <a href={YOUTUBE_GAMEDEV} target="_blank" rel="noreferrer" aria-label="YouTube">
              <Youtube size={18} />
            </a>
            <a href={`mailto:${CONTACT_EMAIL}`} aria-label="Email">
              <Mail size={18} />
            </a>
          </div>
        </div>

        <nav className="footer-nav">
          <span className="footer-nav-title">{t('footer.divisions')}</span>
          {NAV_ITEMS.map((item) => (
            <Link key={item.key} to={item.path}>{t(item.nameKey)}</Link>
          ))}
        </nav>

        <div className="footer-meta">
          <p className="footer-note">{t('footer.note')}</p>
          <p className="footer-copy">© {new Date().getFullYear()} Skycodee. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
}
